import React, { useCallback } from "react";

import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import { EntityTypesSupportedColumnSelection } from "@mapmycustomers/shared/types/entity";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import ColumnModel from "@mapmycustomers/shared/types/viewModel/internalModel/ColumnModel";

import ColumnPane from "@app/component/SelectColumnsPane/ColumnPane";
import ColumnVisibility from "@app/types/viewModel/ColumnVisibility";

interface Props<C extends ColumnModel> {
  columns: C;
  entityType: EntityTypesSupportedColumnSelection;
  fieldFilter?: (field: IField) => boolean;
  onHide: () => void;
  onUpdateColumns?: (columns: C) => void;
}

const SelectColumnsPane = <C extends ColumnModel = ColumnModel>({
  columns,
  entityType,
  fieldFilter,
  onHide,
  onUpdateColumns,
}: Props<C>) => {
  const handleUpdate = useCallback(
    (visibilities: ColumnVisibility[]) => {
      const fieldNameToVisibility = new Map(visibilities.map((v) => [v.field.name, v.visible]));
      const updatedColumns = columns.map(
        (column) =>
          ({
            ...column,
            visible:
              column.field.hasFeature(FieldFeature.ALWAYS_VISIBLE) ||
              (fieldNameToVisibility.get(column.field.name) ?? column.visible),
          } as C[number])
      );
      onUpdateColumns?.(updatedColumns as C);
    },
    [onUpdateColumns, columns]
  );

  return (
    <ColumnPane
      columns={columns}
      entityType={entityType}
      fieldFilter={fieldFilter}
      onHide={onHide}
      onUpdate={handleUpdate}
      showCategories
      visible
    />
  );
};

export default SelectColumnsPane;
